import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DynamicReportGeneralEditComponent } from './dynamic-report-general-edit.component';
import { DynamicReportGeneralResolver } from '../dynamic-report-general.resolver';

const routes: Routes = [
    {
        path: ':id',
        component: DynamicReportGeneralEditComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [DynamicReportGeneralResolver],
})
export class DynamicReportGeneralEditRoutingModule { } 